class SimplePopup {
  constructor() {
    this.popup = document.getElementById('prd-drawer');
    this.getlookPopup = document.getElementById('getlook_sizeguide');
    this.setupEvents();
  }
  
  setupEvents() {
    this.performRecommendations();
    
    document.addEventListener('click', (e) => {
      const target = e.target;
      
      // Handle recommendation links
      if (target.closest('.prd_recom_ancher') || target.closest('.ctm-prd-recommend') && !target.closest('.get_the_look_wrapper')) {        
        e.preventDefault();
        this.openRecommendations(target);
      }

      // Handle Notify Me Pop and Klaviyo integration
      if (target.closest('.ctm_prd_outOfStock')) {
        this.openNotifyMe(target);
      }

      if (target.closest('.notify_me_cta')) {
        this.handleNotifyMe(target);
      }
      
      // Handle size guide buttons
      else if (target.closest('.ctm-product__size_guide-button')) {
        const button = target.closest('.ctm-product__size_guide-button');
        this.openSizeGuide(button);
      }
      
      // Handle getthelook size guide buttons
      else if (target.closest('.getthe_look__size-guide')) {
        e.preventDefault();
        const button = target.closest('.getthe_look__size-guide');
        this.openGetTheLookSizeGuide(button);
      }
      
      // Handle unit buttons (inch/cm)
      else if (target.closest('.prd-size-unit')) {
        const unitButton = target.closest('.prd-size-unit');
        this.handleUnitChange(unitButton);
      }
      
      // Handle feature buttons
      else if (target.closest('.product__feature-drawer-button')) {
        this.openFeatureDrawer(target);
      }
      
      // Handle popup close
      else if (target.closest('.prd-drawer--overlay') || target.closest('.prd-drawer--close-btn')) {
        this.closePopup();
      }
      
      // Handle getlook popup close
      else if (target.closest('.getlook__close_btn') || target.closest('.getlook-drawer--overlay')) {
        this.closeGetLookPopup();
      }
    });
  }

  performRecommendations() {
    const recommendations = document.querySelector('[data-drawer-recommendations]');
    if (!recommendations) return;
    fetch(document.querySelector('.ctm-prd-recommend').dataset.url)
      .then(response => response.text())
      .then(text => {
        const recommendationsHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-drawer-recommendations]')?.innerHTML;
        
        if (!recommendationsHTML) return;
        recommendations.innerHTML = recommendationsHTML;
      });
  }

  // Get size data from script tag for getthelook size guide
  getGetTheLookSizeData(button) {
    try {
      const sizeScript = button.querySelector('script[data-getthelook-size]');
      if (!sizeScript) return null;

      const scriptContent = sizeScript.textContent.trim();
      const sizeGuideMatch = scriptContent.match(/const sizeGuide\s*=\s*({[\s\S]*?});/);
      
      if (!sizeGuideMatch) return null;

      let sizeGuideJson = sizeGuideMatch[1]
        .replace(/,\s*}/g, '}')
        .replace(/,\s*]/g, ']');

      const sizeGuide = JSON.parse(sizeGuideJson);
      return {
        name: sizeGuide.size_guide_name || 'Size Guide',
        in: sizeGuide.inch || sizeGuide.in || [],
        cm: sizeGuide.cm || []
      };
    } catch (error) {
      console.log('Error getting getthelook size data:', error);
      return null;
    }
  }

  // Get size data from script tag for main product
  getSizeData() {
    try {
      const sizeScript = document.querySelector('section.main-product script[data-mainprd-sizeguide]');
      if (!sizeScript) return null;

      const scriptContent = sizeScript.textContent.trim();
      const sizeGuideMatch = scriptContent.match(/const sizeGuide\s*=\s*({[\s\S]*?});/);
      
      if (!sizeGuideMatch) return null;

      let sizeGuideJson = sizeGuideMatch[1]
        .replace(/,\s*}/g, '}')
        .replace(/,\s*]/g, ']');

      const sizeGuide = JSON.parse(sizeGuideJson);
      return {
        in: sizeGuide.inch || sizeGuide.in || [],
        cm: sizeGuide.cm || []
      };
    } catch (error) {
      console.log('Error getting size data:', error);
      return null;
    }
  }

  // Update size table with data
  updateSizeTable(unit, table, sizeData) {
    if (!sizeData) return;

    const data = sizeData[unit.toLowerCase()];
    if (!data || !data.length) return;

    const tableHead = table.querySelector('thead');
    const tableBody = table.querySelector('tbody');
    
    // Get measurement fields (excluding 'size')
    const firstItem = data[0];
    const fields = Object.keys(firstItem).filter(key => key !== 'size');

    // Update headers
    const headerRow = document.createElement('tr');
    headerRow.innerHTML = `<th>SIZE</th>`;
    fields.forEach(field => {
      const text = this.formatHeader(field);
      headerRow.innerHTML += `<th>${text}</th>`;
    });
    tableHead.innerHTML = '';
    tableHead.appendChild(headerRow);

    // Update table body
    tableBody.innerHTML = '';
    data.forEach(item => {
      const row = document.createElement('tr');
      row.innerHTML = `<td>${item.size || ''}</td>`;
      fields.forEach(field => {
        row.innerHTML += `<td>${item[field] || ''}</td>`;
      });
      tableBody.appendChild(row);
    });
  }

  formatHeader(field) {
    const headers = {
      'shoulder': 'SHOULDER',
      'length': 'LENGTH', 
      'chest': 'CHEST',
      'sleeve': 'SLEEVE',
      'sleeve_length': 'SLEEVE LENGTH'
    };
    return headers[field] || field.toUpperCase();
  }

  openGetTheLookSizeGuide(button) {
    const sizeData = this.getGetTheLookSizeData(button);
    if (!sizeData) return;

    const title = `SIZE GUIDE`;
    
    // Create size guide content
    const content = `
      <h3 class="sub--title h6" style="text-align:center; ">FIND YOUR SIZE</h3>
      <div class="prd-size-toggle">
        <button class="prd-size-unit" data-unit="cm">CM</button>
        <button class="prd-size-unit active" data-unit="in">IN</button>
      </div>
      <div class="prd-size--wrapper" id="prdSizeDataTable">
        <table class="prd-size--table">
          <thead>
            <tr>
              <th>(In <span class="unit-display">IN</span>)</th>
            </tr>
          </thead>
          <tbody></tbody>
        </table>
      </div>
    `;

    this.showGetLookPopup(title, content);

    // Update size table with getthelook data
    const table = document.querySelector('#getlook_sizeguide #prdSizeDataTable');
    if (table) {
      this.updateSizeTable('in', table, sizeData);
    }
  }

  openRecommendations(target) {
    const getTheLook = target.closest('.ctm-prd-recommend');
    const recommendations = document.querySelector('.drawer_recomendation_products');
    
    if (!recommendations) {
      console.log('No recommendations found');
      return;
    }
    
    const content = recommendations.innerHTML;

    const title = getTheLook.querySelector('.product-recommendations__title').innerHTML;    

    this.showPopup(title, content);
    this.popup.classList.add('show_popup_size_guide');
    
    recommendations.classList.remove('hidden');
  }

  openNotifyMe(target) {
    const prdInfo = target.closest('.prd_content_info');    
    const onClikedVariant = target.closest('.ctm_prd_outOfStock').dataset
    
    const prd_title = prdInfo.querySelector('.product__title').innerHTML || 'Default title';
    const prd_var_title = prdInfo.querySelector('.active_swatch_name').innerText || 'Black/Charcoal Grey';

    const prd_first_img_src = document.querySelector(".ctm_desk_main_slider .main-product__media--grid-item img").src ||
                               document.querySelector(`.conn_prds--item.active img`).src;

    const notifyMeContent =`
      <section class="notify_me_content" role="region" aria-labelledby="notify_me_title">
        <div class="notify_me_header">
          <h2 id="notify_me_title" class="notify_me_title">selected size</h2>
        </div>

        <div class="notify_me_product">
          <img class="notify_me_thumb" src="${prd_first_img_src}" alt="${prd_title}">
          <div class="notify_me_product_info">
            <p class="notify_me_product_name">${prd_title}</p>
            <p class="notify_me_product_meta">${prd_var_title}</p>
          </div>
        </div>

        <fieldset class="notify_me_sizes" aria-label="Size">
          <legend class="sr-only">Choose a size</legend>
          <button type="button" class="notify_me_size_btn is-selected" aria-pressed="true" data-soldout-var-id="${onClikedVariant.variantId}">${onClikedVariant.variantTitle}</button>
        </fieldset>

        <div class="notify_me_form">
          <label class="notify_me_label" for="notify_me_email">Enter your email address, we will notify you</label>
          <input id="notify_me_email" class="notify_me_input" type="email" inputmode="email" autocomplete="email" placeholder="Please enter your email address" required>
        </div>

        <div class="notify_me_actions">
          <button type="button" class="notify_me_cta">TO REGISTER</button>
        </div>
      </section>
    `

    const title = `STOCK NOTIFICATIONS`;    
    this.popup.classList.add('notify_me_when_ctn');
    this.showPopup(title, notifyMeContent);    

  }

  
  handleNotifyMe(target) {
    const notifyMeContent = target.closest('.notify_me_content');    
    const emailInput = notifyMeContent.querySelector('#notify_me_email');
    const email = emailInput.value.trim();
    
    const selectedSizeBtn = notifyMeContent.querySelector('.notify_me_size_btn.is-selected');
    const rawVariantId = selectedSizeBtn.getAttribute('data-soldout-var-id');
    
    const variantId = `$shopify:::$default:::${rawVariantId}`;
    
    const productName = notifyMeContent.querySelector('.notify_me_product_name').textContent;
    const productColor = notifyMeContent.querySelector('.notify_me_product_meta').textContent;
    
    if (!email) {
      alert('Please enter your email address');
      emailInput.focus();
      return;
    }
    
    if (!this.isValidEmail(email)) {
      alert('Please enter a valid email address');
      emailInput.focus();
      return;
    }
    
    if (!rawVariantId) {
      console.error('Variant ID not found for product:', productName);
      alert('Error: Product variant information missing. Please try again.');
      return;
    }
    
    // Prepare Klaviyo payload
    const payload = {
        "data": {
            "type": "back-in-stock-subscription",
            "attributes": {
                "profile": {
                    "data": {
                        "type": "profile",
                        "attributes": {
                            "email": email
                        }
                    }
                },
                "channels": ["EMAIL"]
            },
            "relationships": {
                "variant": {
                    "data": {
                        "type": "catalog-variant",
                        "id": variantId 
                    }
                }
            }
        }
    };
    
    console.log('Subscribing to back-in-stock:', {
        product: productName,
        color: productColor,
        email: email,
        rawVariantId: rawVariantId,
        formattedVariantId: variantId
    });

    const PUBLIC_API_KEY = `WXB8U4`;
    
    fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${PUBLIC_API_KEY}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'revision': '2024-02-15'
        },
        body: JSON.stringify(payload)
    })
    .then(response => {
        if (response.ok) {
            alert(`Successfully subscribed! We will notify you when ${productName} in ${productColor} is back in stock.`);
            emailInput.value = ''; 
            
            this.showSubscriptionSuccess(notifyMeContent);
        } else {
            return response.json().then(errorData => {
                console.error('Klaviyo API Error:', errorData);
                alert('There was an issue subscribing. Please check your email and try again.');
            });
        }
    })
    .catch(error => {
        console.error('Network Error:', error);
        alert('A network error occurred. Please try again.');
    });
  }

  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  showSubscriptionSuccess(notifyMeContent) {
    const ctaButton = notifyMeContent.querySelector('.notify_me_cta');
    const originalText = ctaButton.textContent;
    
    ctaButton.textContent = 'SUCCESSFULLY REGISTERED!';
    ctaButton.style.backgroundColor = '#28a745'; 
    ctaButton.disabled = true;
    
    setTimeout(() => {
        ctaButton.textContent = originalText;
        ctaButton.style.backgroundColor = '';
        ctaButton.disabled = false;
    }, 3000);
  }

  openSizeGuide(button) {
    const sizeGuideData = document.getElementById('size-guide-drawer-content');
    if (!sizeGuideData) return;

    const title = sizeGuideData.querySelector('.prd-drawer--title')?.innerHTML || '';    
    const content = sizeGuideData.querySelector('.prd-drawer--content')?.innerHTML || '';
    
    this.showPopup(title, content);

    // Update size table with main product data
    const table = document.getElementById('prdSizeDataTable');
    const unit = table?.querySelector('.unit-display')?.textContent;
    if (table && unit) {
      this.updateSizeTable(unit, table, this.getSizeData());
    }
  }

  handleUnitChange(unitButton) {
    const parent = unitButton.closest('.prd-size-toggle');
    let table;
    let sizeData;
    
    if (this.getlookPopup.classList.contains('show_popup')) {
      table = this.getlookPopup.querySelector('#prdSizeDataTable');
      const getLookButton = document.querySelector('.getthe_look__size-guide');
      sizeData = this.getGetTheLookSizeData(getLookButton);
    } else {
      table = document.getElementById('prdSizeDataTable');
      sizeData = this.getSizeData();
    }
    
    // Update active button
    parent.querySelectorAll('.prd-size-unit').forEach(btn => {
      btn.classList.remove('active');
    });
    unitButton.classList.add('active');

    // Update table
    if (table && sizeData) {
      this.updateSizeTable(unitButton.dataset.unit, table, sizeData);
    }
  }

  openFeatureDrawer(button) {
    const featureButton = button.closest('.product__feature-drawer-button');
    const title = featureButton.querySelector('span')?.textContent || '';
    const content = featureButton.nextElementSibling?.innerHTML || '';
    
    this.showPopup(title, content);
  }

  showPopup(title, content) {
    if (!this.popup) return;

    const titleEl = this.popup.querySelector('.prd-drawer--title');
    const contentEl = this.popup.querySelector('.prd-drawer--content');

    if (titleEl) titleEl.innerHTML = title;
    if (contentEl) contentEl.innerHTML = content;

    this.popup.classList.add('show_popup');
    setTimeout(() => this.popup.classList.add('enable_popup'), 100);
  }

  showGetLookPopup(title, content) {
    if (!this.getlookPopup) return;

    const titleEl = this.getlookPopup.querySelector('.prd-drawer--title');
    const contentEl = this.getlookPopup.querySelector('.prd-drawer--content');

    if (titleEl) titleEl.innerHTML = title;
    if (contentEl) contentEl.innerHTML = content;

    this.getlookPopup.classList.add('show_popup');
    setTimeout(() => this.getlookPopup.classList.add('enable_popup'), 100);
  }

  closePopup() {
    if (!this.popup) return;

    const contentEl = this.popup.querySelector('.prd-drawer--content');
    if (contentEl) contentEl.innerHTML = '';

    this.popup.classList.remove('enable_popup');
    this.popup.classList.remove('show_popup_size_guide', 'notify_me_when_ctn');

    setTimeout(() => this.popup.classList.remove('show_popup'), 500);
  }

  closeGetLookPopup() {
    if (!this.getlookPopup) return;

    const contentEl = this.getlookPopup.querySelector('#getlook_sizeguide .prd-drawer--content');
    if (contentEl) contentEl.innerHTML = '';

    this.getlookPopup.classList.remove('enable_popup');
    setTimeout(() => this.getlookPopup.classList.remove('show_popup'), 500);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new SimplePopup();
});

//////////////////// Video Js For the Product page ////////////////////////
document.addEventListener('click', async (e) => {
  let item = e.target;
  
  if(item.closest('.vid--action-button')){
    let i = item.closest('.vid--action-button');
    let video = i.closest('.vid-grid--item').querySelector('video');
    
    if(i.classList.contains('vid--mute')){
      if(i.classList.contains('mute--active')){
        i.classList.remove('mute--active');
        video.volume = 1;
      }else{
        i.classList.add('mute--active');
        video.volume = 0;
      }
      
    }
    else if(i.classList.contains('vid--pause')){
      if(i.classList.contains('play--active')){
        i.classList.remove('play--active');
        video.pause()
      }else{
        i.classList.add('play--active');
        video.play();
      }
    }
  }

  if (item.closest('.vid_content_btn')) {
    const vdoContentBtn = item.closest('.vid_content_btn');
    const videoItem = vdoContentBtn.closest('.vid-grid--item');

    if (vdoContentBtn.classList.contains('vid_btn_content_disable')) {
      videoItem.classList.add("video_content_active");
      vdoContentBtn.classList.remove("vid_btn_content_disable");
      vdoContentBtn.classList.add('vid_btn_content_enable');
    } else {
      videoItem.classList.remove("video_content_active");
      vdoContentBtn.classList.add("vid_btn_content_disable");
      vdoContentBtn.classList.remove('vid_btn_content_enable');
    }
  }

  if(item.closest('#copyBtn')){
    let e = item.closest('#copyBtn');
    let code = e.dataset.shareCode;
    try {
      await navigator.clipboard.writeText(code);
      copyBtn.classList.add('show-tooltip');
      setTimeout(() => copyBtn.classList.remove('show-tooltip'), 1000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  }
});

var swiper = new Swiper(".product__text-slider-swiper", {
  loop: true,
  slidesPerView: 1,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  speed: 1500,  // controls transition speed
  effect: "fade",  // makes the transition fade smoothly
  fadeEffect: {
    crossFade: true,  // enables smoother fade effect
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,  // allows the user to click on pagination to navigate
  },
});


// if( window.innerWidth < 769){
//   let ss = document.querySelectorAll('.vid-grid--content');
//   let ssW = document.querySelectorAll('.vid-grid--content-wrapper');
//   let ssW_item = document.querySelectorAll('.vid-grid--item');

//   ss.forEach( a => a.classList.add('swiper') );
//   ssW.forEach( a => a.classList.add('swiper-wrapper') );
//   ssW_item.forEach( a => a.classList.add('swiper-slide') );

//   var swiper = new Swiper(".vid-grid--content", {
//     loop: false,
//     slidesPerView: 1,
//     spaceBetween: 10,
//     freeMode: true,
//   });
// }
////////////////////END Video Js For the Product page ////////////////////////
